import { Graph, RewindPlay, Toggle, Flask, Person, Server, Database, Terminal } from '@posthog/icons'

export const slideButtons = [
    {
        title: 'Product analytics',
        Icon: Graph,
        color: 'blue',
    },
    {
        title: 'Session replay',
        Icon: RewindPlay,
        color: 'yellow',
    },
    {
        title: 'Feature flags',
        Icon: Toggle,
        color: 'teal',
    },
    {
        title: 'A/B testing',
        Icon: Flask,
        color: 'purple',
    },
    {
        title: 'CDP',
        Icon: Person,
        color: 'yellow',
    },
    {
        title: 'Data warehouse',
        Icon: Server,
        color: 'seagreen',
    },
    {
        title: 'SQL',
        Icon: Database,
        color: 'salmon',
    },
    /*
    {
        title: 'API',
        Icon: Terminal,
        color: 'blue',
    },
    */
]
